import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  updateCurrentTrimRangeCreator,
  updateSelectedTrimRangeCreator,
} from 'creators/trimming';
import { percentify, percentifyRaw } from 'utilities/videoPlayer';

import TrimRangeMarker from './trim-range-marker';

import './styles.less';

class TrimRangesBar extends Component {
  render() {
    const {
      currentTrimRange,
      duration,
      selectedTrimRange,
      trimRanges,
    } = this.props;

    const trimRangeMarkers = trimRanges
      .map(range => {
        // we're currently editing this trim, don't render its marker
        if (currentTrimRange != null && range.id === currentTrimRange.id) {
          return null;
        }

        const { from, id, to } = range;
        const leftPercent = percentifyRaw(from / 1000, duration);
        const rightPercent = percentifyRaw(to / 1000, duration);

        const markerStyle = {
          left: percentify(from / 1000, duration),
          width: `${rightPercent - leftPercent}%`,
        };

        return (
          <TrimRangeMarker
            key={id}
            style={markerStyle}
            active={
              selectedTrimRange == null || selectedTrimRange.id === range.id
            }
            selected={
              selectedTrimRange != null && selectedTrimRange.id === range.id
            }
            onClick={e => {
              e.stopPropagation();
              this.props.updateSelectedTrimRangeCreator(range);
            }}
            onEditClick={e => {
              e.stopPropagation();
              this.props.updateCurrentTrimRangeCreator(range);
            }}
            onDeselect={this.onDeselectMarker}
          />
        );
      })
      .filter(Boolean);

    return (
      <div className="video-player-trim-ranges-bar">{trimRangeMarkers}</div>
    );
  }

  onDeselectMarker = () => {
    if (this.props.selectedTrimRange != null) {
      this.props.updateSelectedTrimRangeCreator(null);
    }
  };
}

const mapStateToProps = state => {
  const {
    current_trim_range: currentTrimRange,
    selected_trim_range: selectedTrimRange,
    trim_ranges: trimRanges,
  } = state.trimming;

  return {
    currentTrimRange,
    selectedTrimRange,
    trimRanges,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateCurrentTrimRangeCreator: trimRange =>
      dispatch(updateCurrentTrimRangeCreator(trimRange)),
    updateSelectedTrimRangeCreator: trimRange =>
      dispatch(updateSelectedTrimRangeCreator(trimRange)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrimRangesBar);
